/* Add fn_checkPageEnabled, Amend btn-create-new  Apr 13, 2024 */
template(lang="pug")
  div.top-nav
    // Main left section — hidden on settings or create pages
    div(v-show="!/^(settings)$|(-create)$/.test(c_hb)")
      
      // Upload buttons — only visible on #extr pages
      div(v-show="/^(#extr)/.test(c_hb)")
        b-button(
          v-if="c_isMobile"
          class="btn-upload"
          style="border:none;"
          variant="outline-primary"
          @click="m_uploadCamera"
        )
          fa-icon(icon="camera")

        b-button(
          v-else
          class="btn-upload"
          title="Upload Business Card"
          style="border:none;"
          variant="outline-primary"
          @click="m_fileUpload"
        )
          b-icon(icon="upload")

      // Create New button
      b-button(
        v-if="m_checkPage('Create New')"
        class="btn-create-new"
        variant="outline-primary"
        @click="m_createNew"
      )
        fa-icon(icon="folder-plus" class="mr-1")
        | Create New

    // Right section — global search
    div
      kt-select(
        id="kt-search-all"
        ref="kt-search-all"
        p_appEntKey="all"
        p_noIcon=true
        p_searcher=true
        p_placeholder="Search Entire System"
      )


<script>
import {fn_checkPageEnabled,fn_getHashBase, fn_getMoal_createNew} from "@/utils/util.js";
import {fn_appEnt,appEntities} from "@/utils/ref-data.js";
import { eventBus } from '@/main';

const aeRE = new RegExp('^(oppr|proj|acct|cmpt|extr|team)');
export default {
	name: "top-nav",
	components: {},
	created() {
			//eventBus.$on('table', (data) => {this.d_entityLabel=data;});
	},
	mounted() {},
	data() {
		return {
			d_crtNwKey: 'oppr',
			d_entityLabel:null,
		};
	},
	props: {},
	computed: {
		c_hb() {
			return fn_getHashBase(this);
		},
		c_crtNwOpts() {
			return appEntities.filter(x => aeRE.test(x.key)).map(x => ({'value': x.key, 'text': x.Name}));
		},
		c_isMobile() {return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);},

	},
	methods: {
		m_checkPage(page){
							var hashBase=fn_getHashBase(this);
							var label=fn_appEnt(hashBase)?.label;
							if(label&&label!='undefined') return fn_checkPageEnabled(label,page); else return fn_checkPageEnabled(page);
		},
		m_createNew: function() {
			let h = this.c_hb;
			// if (/^(|dashboard|calendar|cal-activities|salesGoals)$/.test(h)) {
			if (aeRE.test(h)) {
				let href = '#' + h.replace(new RegExp(/(-view)|(-edit)|(-activities)/), '') + '-create';
				this.$router.push(href);
			}
			else {
				let cnm = fn_getMoal_createNew(this);
				let _this = this;
				_this.$bvModal.msgBoxConfirm([cnm.msgVNode], cnm.opt).then(resp => {
					if (!resp) return;
					else {
						let href = '#' + this.d_crtNwKey + '-create';
						this.$router.push(href);
					}
				});
				return;
			}
		},
	},
	m_uploadCamera(){
	
	const input = document.createElement("input");
	input.type = "file";
	input.id = "cameraInput"
	input.accept = "image/*";
	input.capture = "environment";
	input.style = "display:none";

	
  	input.onchange = (e) => {
			const file = e.target.files[0];
			this.d_resumeFile = file;
			this.m_processFile();
		};
		
	input.click();
	
	},
	m_fileUpload(){

		const input = document.createElement("input");
		input.type = "file";
		//input.accept = ".pdf,.doc,.docx";

		input.onchange = (e) => {
			const file = e.target.files[0];
			this.d_resumeFile = file;
			this.m_processFile();
		};

		input.click();
	},
	m_processFile(){
       let promptText = `You are a data extraction engine. Extract the contact information from this business card image and return the result strictly as a JSON object with the following fields: contactName, role, companyName, address, email, telephone. If a field is missing, set its value to null. Do not include any extra text outside the JSON."
       Follow the following rules strictly:
       1.You MUST use the exact field names shown in the schema.
         - Do NOT change casing.
         - Do NOT convert to snake_case, kebab-case, or any other format.
         - Any deviation from the schema is considered invalid output.
         - Do not return unknown for missing data.
		 
	   2. Return JSON in this exact schema:
        contact:{contactName: "string",
	         role: "string",
			 firstName:"string",
			 lastName:"string",
			 companyName:"string",
			 mobilePhoneNo: 'string",
			 phoneNo:"string",
			 officPhoneNo:"string",
			 streetAddress: "string"
			 city:"string",
			 stateProvince:"string",
			 zipCode: "string"
			 }`;
 

    this.d_loading=true;



    const payload = {prompt:promptText};

 // Build FormData
    const formData = new FormData();

    // Append JSON payload as a string
    formData.append("payload", JSON.stringify(payload));

    // Append the file
    formData.append("resume", this.d_resumeFile);
	

fn_callAIProcessFile(formData)
  .then(resp => {
	 
  
  
  eventBus.$emit('businessCardUpload',resp.contact);
  this.d_loading = false;
  
  })

  .catch(err => {
    console.error(err);
    this.d_loading = false;

    const status = err?.response?.status;

    if (status === 500 || status === 503) {
      kbdpAlert.showErr("AI outage, kindly retry");
      return;
    }

    kbdpAlert.showErr("Error: Unable to upload resume, file might be too large!!");
  });

  
  },

}
</script>

<style lang="less">
.top-nav {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	> div:first-child {
		.btn-create-new {
			white-space: nowrap;
			font-size: 0.9em;
			padding: 0em 0.3em;
			margin: 0.2em 0em;
			border:none
		}
	}
	> div:last-child {
		text-align: left;
		margin: auto 0;
		width: 300px;
		div.kt-select {
			margin: 0 0.4em;

			div.input {
				padding-top: 0em;
				padding-bottom: 0em;
				div.input-text {
					display: block;
				}
			}
			.btn-clear {
				line-height: 1em;
			}
			div.options-container {
				font-size: 0.9em;
			}
		}
	}
}
</style>